export const authSessionQueryKey = ['auth', 'me-session'] as const
